var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrendUp = function SvgTrendUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52875,9.52875 L3.52875,9.52875 C3.8208471,9.8208471 4.29436467,9.82105906 4.58672315,9.52922358 L8.25,5.8725 L8.25,15 L9.75,15 L9.75,5.8725 L13.4029769,9.53202349 C13.6965422,9.82611488 14.1729321,9.82654137 14.4670235,9.53297608 C14.4671824,9.53281746 14.4673412,9.53265877 14.4675,9.5325 L14.4675,9.5325 C14.7615916,9.23840837 14.7615916,8.76159163 14.4675,8.4675 L9,3 L3.52875,8.47125 C3.23672944,8.76327056 3.23672944,9.23672944 3.52875,9.52875 Z",
    id: "Shape",
    fill: "#00B197",
    fillRule: "nonzero"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrendUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trend-up.6c36b253.svg";
export { ForwardRef as ReactComponent };